import React, {Component} from 'react'
import {connect} from 'react-redux'
import * as actions from '../../state/actions'
import {bindActionCreators} from 'redux'
import {Alert} from 'react-bootstrap'
import Spinner from './../common/Spinner'
import { browserHistory } from 'react-router'
import moment from 'moment'

class EntityDetail extends Component {

    constructor(props) {
        super(props)
        let self = this
        self.state = {

        }
    }

    componentDidMount() {
        var self = this
        self.props.actions.entityGetOne(self.props.params.appCodename, self.props.params.entityId)
    }

    goBack() {
        browserHistory.go(-1)
    }

    render() {
        var self = this
        if (!self.props.entity) {
            return (<Spinner/>)
        } else if (self.props.entity && !self.props.entity._id) {
            return (
                <Alert bsStyle='warning'>
                    <strong>No se encontraron productos!</strong>
                </Alert>
            )
        } else {
            let en = self.props.entity

            var dateTime = new Date(en.createdAt)
            dateTime = moment(dateTime).format('YYYY-MM-DD HH:mm:ss')
            let externalid = en.externalId ? en.externalId : '-'
            let name = en.name ? en.name : '-'
            let fee = en.fee ? en.fee + '%' : '-'
            let accessToken = en.accessToken ? en.accessToken : '-'
            let publicKey = en.publicKey ? en.publicKey : '-'
            let userId = en.userId ? en.userId : '-'
            let refreshToken = en.refreshToken ? en.refreshToken : '-'
            let expiresIn = en.expiresIn ? en.expiresIn : '-'

            return (
                <div>
                    <div className='row'>
                        <div className='col-lg-12' key='infoEntity'>
                            <h1 className='page-header'>Información de la transacción</h1>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12' key='detail'>
                            <table className='table table-bordered table-hover'>
                                <tbody>
                                    <tr className='active' key='dateTime'>
                                        <td className='col-md-2'>
                                            <b>Fecha</b>
                                        </td>
                                        <td className='col-md-10'>{dateTime}</td>
                                    </tr>
                                    <tr key='externalid'>
                                        <td className='col-md-2'>
                                            <b>External Id</b>
                                        </td>
                                        <td className='col-md-10'>{externalid}</td>
                                    </tr>
                                    <tr className='active' key='name'>
                                        <td className='col-md-2'>
                                            <b>Nombre</b>
                                        </td>
                                        <td className='col-md-10'>{name}</td>
                                    </tr>
                                    <tr key='fee'>
                                        <td className='col-md-2'>
                                            <b>Fee</b>
                                        </td>
                                        <td className='col-md-10'>{fee}</td>
                                    </tr>
                                    <tr className='active' key='accessToken'>
                                        <td className='col-md-2'>
                                            <b>Access Token</b>
                                        </td>
                                        <td className='col-md-10'>{accessToken}</td>
                                    </tr>
                                    <tr key='publicKey'>
                                        <td className='col-md-2'>
                                            <b>Public Key</b>
                                        </td>
                                        <td className='col-md-10'>{publicKey}</td>
                                    </tr>
                                    <tr className='active' key='userId'>
                                        <td className='col-md-2'>
                                            <b>User Id</b>
                                        </td>
                                        <td className='col-md-10'>{userId}</td>
                                    </tr>
                                    <tr key='refreshToken'>
                                        <td className='col-md-2'>
                                            <b>Refresh Token</b>
                                        </td>
                                        <td className='col-md-10'>{refreshToken}</td>
                                    </tr>
                                    <tr className='active' key='expiresIn'>
                                        <td className='col-md-2'>
                                            <b>Expires In</b>
                                        </td>
                                        <td className='col-md-10'>{expiresIn}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        entity: state.entity
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(EntityDetail)



// WEBPACK FOOTER //
// ./components/EntityDetail/index.js